import styles from './CarrelloImpostazioniSection.module.scss';

export type CarrelloImpostazioniSectionProps = {
  title: string;
  children: React.ReactNode;
};

export const CarrelloImpostazioniSection = ({ title, children }: CarrelloImpostazioniSectionProps) => {
  return (
    <fieldset className={styles.container}>
      <legend className={styles.title}>{title}</legend>
      <div className={styles.wrapper}>{children}</div>
    </fieldset>
  );
};
